import axios from "axios";
import React from "react";



class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      memberDetails: '',
      memberFamily: [],
      loader_status: false,
      try_again_status: false,
      main_content_status: false,
    };
  }

  setLoaderFunction = () => {

    this.setState({
      loader_status: true,
      try_again_status: false,
      main_content_status: false,
    });
  };
  closeLoaderFuncion = () => {
    this.setState({
      loader_status: false,
      try_again_status: false,
      main_content_status: true,
    });
  };

  enableTryAgain = () => {

    this.setState({
      loader_status: false,
      try_again_status: true,
      main_content_status: false,
    });
  };



  componentDidMount() {
    this.getDataForView();
  }


  async getDataForView() {
    try {
      this.setLoaderFunction()
      const token = localStorage.getItem("token");
      const id = this.props.leadId
      const [
        { data: member },
      ] = await Promise.all([
        axios.get("api/customer/edit/for/member", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } })
      ]);
      const memebrs = member.customer_basic_detail;
      this.setState({ memberDetails: memebrs });
      this.setState({ memberFamily: member.customer_basic_detail.contact_people });
      this.closeLoaderFuncion()

    } catch (error) {
      console.error("Error fetching data: ", error);
      this.enableTryAgain()
    }
  }



  tryAgain = () => {

    this.getDataForView()

  }



  render() {


    const Family = () => (<table className="min-w-full divide-y divide-gray-300">
      <thead className="bg-gray-50">
        <tr>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            #
          </th>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            Name
          </th>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            Dob
          </th>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            Gender
          </th>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            Blood Group
          </th>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            Mobile
          </th>

        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        {this.state.memberFamily.map((person, index) => (
          <tr key={person.id}>
            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{index + 1}</td>
            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.contact_person_first}</td>
            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.contact_person_date_of_birth}</td>
            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.contact_people_gender?.name}</td>
            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.contact_people_blood_group?.name}</td>
            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.contact_person_mobile}</td>

          </tr>
        ))}
      </tbody>
    </table>)

    const Profile = () => (
      <div className="overflow-hidden bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg font-medium leading-6 text-gray-900">Profile Information</h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">Personal details of Member</p>
        </div>
        <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
          <dl className="sm:divide-y sm:divide-gray-200">
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Name</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{this.state.memberDetails.primary_contact_first_name}</dd>
            </div>
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">House Number</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{this.state.memberDetails.house_number?.house_number}</dd>
            </div>
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Mobile</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{this.state.memberDetails.customer_mobile}</dd>
            </div>
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Fee Type</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{this.state.memberDetails.item?.name}</dd>
            </div>
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Blood Group</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{this.state.memberDetails?.blood_group?.name}</dd>
            </div>
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Gender</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{this.state.memberDetails?.gender?.name}</dd>
            </div>
            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Address</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                {this.state.memberDetails?.customer_address?.billing_address_street_one}<br />
                {this.state.memberDetails?.customer_address?.billing_address_street_two}<br />
                {this.state.memberDetails?.customer_address?.billing_city}<br />
                {this.state.memberDetails?.customer_address?.billing_phone}<br />
                {this.state.memberDetails?.customer_address?.billing_zip_code}<br />

              </dd>
            </div>

            <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Family Members Details</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                <Family />
              </dd>
            </div>
          </dl>
        </div>
      </div>
    )




    return (
      <>

        {/* Content area */}

        <div className="flex flex-col flex-1">

          
          {this.state.loader_status && (
            <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
              <div className="bg-white p-4 rounded-md">
                <div className="flex items-center justify-center">
                  <div
                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                </div>
                <p className="text-center mt-4">Loading...</p>
              </div>
            </div>
          )}
          {/*loader_status------------------------------------------------------------------------*/}

          {/*try_again_status-----------------------------------------------------------------------------*/}
          {this.state.try_again_status && (
            <div className="h-screen flex items-center justify-center bg-white ">
              <div className="flex flex-col items-center justify-center h-full">
                <p className="text-red-500">{this.state.error_customize}</p>
                <button
                  type="button"
                  onClick={this.tryAgain}
                  className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  TryAgain
                </button>
              </div>
            </div>
          )}
          {/*try_again_status-----------------------------------------------------------------------------*/}

          {this.state.main_content_status && (
            <main className="flex-1">
              <Profile />
            </main>
          )}
        </div>

      </>
    )
  }
}

export default Profile;